// ismobile.js ライブラリを利用してモバイルデバイス判定を行うコンポーザブル関数
import { ref } from 'vue';
import isMobile from 'ismobilejs';

export function useIsMobile() {
    // `ismobilejs` を利用してページが読み込まれた時点でデバイスの種類を判断
    const isMobileDevice = ref(isMobile().any);

    return { isMobileDevice };
}

